    // Get the modal
  var modal = document.getElementById("myModal");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks the button, open the modal
  window.onload = function () {
    modal.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }


  // Grabar
      function setCookie(name, value, expires, path, domain, secure) {
          document.cookie = name + "=" + escape(value) +((expires == null) ? "" : "; expires=" + expires.toGMTString()) +
          ((path == null) ? "" : "; path=" + path) +((domain == null) ? "" : "; domain=" + domain) +
          ((secure == null) ? "" : "; secure");
      }
      // Leer
      function getCookie(name){
          var cname = name + "=";
          var dc = document.cookie;
          if (dc.length > 0) {
              begin = dc.indexOf(cname);
              if (begin != -1) {
                  begin += cname.length;
                  end = dc.indexOf(";", begin);
                  if (end == -1) end = dc.length;
                      return unescape(dc.substring(begin, end));
                  }
              }
          return null;
      }
      //Borrar
      function delCookie (name,path,domain) {
          if (getCookie(name)) {
              document.cookie = name + "=" + ((path == null) ? "" : "; path=" + path) +
              ((domain == null) ? "" : "; domain=" + domain) + "; expires=Thu, 01-Jan-22 00:00:01 GMT";
          }
          }